// Platform brand logo — dynamic name/logo (editable by super admin) with image fallback.
import { useAuth } from "../context/AuthContext";
import { fileUrl } from "../lib/api";
import wzLogo from "../assets/workzone-logo.png";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img src={wzLogo} alt="WorkZone" className={`${className} object-contain rounded-lg bg-white`} />
);

export const Logo = ({
  size = "md",
  tagline = false,
  textClass = "text-slate-900",
  className = "",
}) => {
  const auth = useAuth();
  const platform = auth?.platform || {};
  const name = platform.name || "WorkZone";
  const tag = platform.tagline || "إدارة أذكى • أداء أفضل";
  const dims = { sm: "h-7 w-7", md: "h-9 w-9", lg: "h-12 w-12" };
  const txt = { sm: "text-lg", md: "text-xl", lg: "text-3xl" };
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="platform-logo" dir="ltr">
      {platform.logo_id
        ? <img src={fileUrl(platform.logo_id)} alt={name} className={`${dims[size] || dims.md} object-contain rounded-lg`} />
        : <LogoMark className={dims[size] || dims.md} />}
      <div className="flex flex-col leading-none">
        <span className={`font-heading font-extrabold tracking-tight ${txt[size] || txt.md} ${textClass}`} dir="ltr">
          {name}
        </span>
        {tagline && (
          <span className="font-heading text-[11px] font-semibold text-emerald-600 mt-1" dir="rtl">
            {tag}
          </span>
        )}
      </div>
    </div>
  );
};
